import { render } from "./ModalConfirmClonePrice.vue?vue&type=template&id=524e1e14"
import script from "./ModalConfirmClonePrice.vue?vue&type=script&lang=js"
export * from "./ModalConfirmClonePrice.vue?vue&type=script&lang=js"

import "./ModalConfirmClonePrice.vue?vue&type=style&index=0&id=524e1e14&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__